import { useMemo } from 'react';
import type React from 'react';

import { Helmet } from 'react-helmet-async';
import { useLocation } from 'react-router';

import { useUtilityContext } from '@change-corgi/core/react/utilityContext';

export const MetaUrlContainer: React.FC = () => {
	const { resolveUrl } = useUtilityContext();
	const { pathname } = useLocation();

	const canonicalUrl = useMemo(() => {
		return resolveUrl(pathname);
	}, [pathname, resolveUrl]);

	return (
		<Helmet>
			{/* Override those in child components of App if necessary */}
			<link rel="canonical" href={canonicalUrl} />
			<meta property="og:url" content={canonicalUrl} />
		</Helmet>
	);
};
